// @flow

import * as React from 'react';
import classNames from 'classnames';

// $FlowFixMe
import type { ModalProps } from './shared';

import {
  Modal as StyledModal,
  Container,
  Header,
  Content,
  Footer,
} from './styled_modal';
import { PaperComponent, ModalTitle, CloseIcon } from './shared';

type ContainerProps = {
  open: boolean,
  closeModal: Function,
  fullScreen?: boolean,
  fullWidth?: boolean,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  width?: string,
  onClose?: Function,
  id?: string,
  modalProps?: Object,
  ariaLabelledBy?: string,
  ariaDescribedBy?: string,
  draggable?: boolean,
  disableEnforceFocus?: boolean,
  children?: React.Node,
};

const StandardContainer = (props: ContainerProps) => {
  const {
    ariaLabelledBy,
    ariaDescribedBy,
    children,
    closeModal,
    draggable,
    modalProps,
    onClose,
    ...containerProps
  } = props;

  return (
    <Container
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      onClose={closeModal}
      onExit={onClose}
      {...containerProps}
      {...modalProps}
      {...(draggable ? { PaperComponent: PaperComponent } : {})}
    >
      {children}
    </Container>
  );
};

StandardContainer.defaultProps = {
  ariaLabelledBy: 'modal_title',
};

type HeaderProps = {
  title: string,
  closeModal: Function,
  displayXIcon?: boolean,
  draggable?: boolean,
  className?: string,
};

const StandardHeader = (props: HeaderProps) => {
  // Copy of TitleSection from components/modals/shared.js
  const { title, closeModal, displayXIcon, draggable, className } = props;

  return (
    <Header
      className={classNames('title-section', className)}
      style={{ cursor: draggable ? 'move' : 'auto' }}
    >
      <ModalTitle id="modal_title">{title}</ModalTitle>
      {displayXIcon && <CloseIcon onClick={closeModal} />}
    </Header>
  );
};

const StandardContent = Content;
const StandardFooter = Footer;

export {
  StandardContainer as Container,
  StandardHeader as Header,
  StandardContent as Content,
  StandardFooter as Footer,
  StyledModal as Modal,
};

const DefaultModal = (props: ModalProps) => {
  const { children, dividers, title, displayXIcon, ...restProps } = props;

  return (
    <StyledModal>
      <StandardContainer {...restProps}>
        <StandardHeader
          title={title}
          displayXIcon={displayXIcon}
          {...restProps}
        />
        <StandardContent dividers={dividers}>{children}</StandardContent>
      </StandardContainer>
    </StyledModal>
  );
};

DefaultModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'md',
  displayXIcon: true,
  draggable: true,
};

export default DefaultModal;
